import {GroupParticipantType} from '../../../../core/rest-client/aat';

/**
 * Column the results are ordered by when a new search is executed and the user has not
 * requested any other order yet. The criterion the user searched by is the one the results
 * are the most readable by, so it becomes the default sorted column.
 *
 * A search by agency name returns PCCs, so their agency name column is the matching one.
 */
const DEFAULT_SORT_BY: Record<GroupParticipantType, string> = {
    [GroupParticipantType.Pcc]: 'pcc',
    [GroupParticipantType.Country]: 'country',
    [GroupParticipantType.AgencyName]: 'agencyName',
    [GroupParticipantType.SabreId]: 'sabreId',
    [GroupParticipantType.AgentName]: 'name'
};

export function getDefaultSortByForSearchType(type?: GroupParticipantType): string | undefined {
    return type
        ? DEFAULT_SORT_BY[type]
        : undefined;
}
